import ActivityManagerModule from './activity.module';
import ZoomModule from './zoom.module';

export default {
  ActivityManagerModule,
  ZoomModule,
};
